import { makeStyles } from 'tss-react/mui';

const useStylesStatisticsBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  statisticsBlock: {
    height: 70,
    padding: 5,
    borderTop: `1px solid ${theme.palette.info.main}`,
  },
  statisticsItemBlock: {
    minWidth: 230,
    padding: '6px 10px',
    textAlign: 'left',
  },
  statisticsItemBlockName: {
    letterSpacing: '0.5px !important',
  },
  statisticsItemBlockValue: {
    fontSize: 18,
  },
}));

export default useStylesStatisticsBlock;
